export default __webpack_public_path__ + "static/media/05-GoldenDonut.df91363f.png";